module.exports = __webpack_public_path__ + "static/img/office (6).19ce243c.jpg";